import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService, sort} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {user} from "../../../models/user";
import {scrollTo} from "../../../service/ToolsService";

type UserListProp = {
  users: user[],
  loading?: boolean,
  sort: sort,
  refresh: () => void
  order: (s: string) => void
}

export const UserList = ({users, loading, refresh, order, sort}: UserListProp) => {
  const [del, setDel] = useState(undefined as undefined | user);

  const deleteUser = async (user: user) => {
    await ApiService.delete(`/user/${user.userId}`);
    refresh();
  };

    const status = (user: user) => {
    if (! user.verified) {
      return <span className="badge bg-info">en cours</span>;
    }

    if (! user.enabled) {
      return <span className="badge bg-warning">incatif</span>;
    }

    return <span className="badge bg-success">actif</span>;
  }

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th onClick={() => order('username')} className="cursor-pointer">
              <span className={sort.by === 'username' ? 'd-flex justify-content-between' : ''}>
                Login
                {sort.by === 'username' && (<>
                  <i className={`me-2 fa-solid ${sort.direction === 'DESC' ? 'fa-sort-up' : 'fa-sort-down'}`} />
                </>)}
              </span>
          </th>
          <th onClick={() => order('email')} className="cursor-pointer">
              <span className={sort.by === 'email' ? 'd-flex justify-content-between' : ''}>
                Email
                {sort.by === 'email' && (<>
                  <i className={`me-2 fa-solid ${sort.direction === 'DESC' ? 'fa-sort-up' : 'fa-sort-down'}`} />
                </>)}
              </span>
          </th>
          <th>Roles</th>
          <th className="text-center w100px">Status</th>
          <th className="text-center w150px">Modification</th>
          <th className="w250px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={6} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && users.map((user: user, i: number) => (
          <tr key={i} className={user.verified ? '' : ' table-info'}>
            <td>{user.username}</td>
            <td>{user.email}</td>
            <td>{user.roles.map((r: string, i: number) => (<p className="m-0 p-0" key={i}>{r}</p>))}</td>
            <td className="text-center">
              {status(user)}
            </td>
            <td className="text-center">
              {DateService
                .toLocaleString(user.updatedAt ?? user.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/user/edit/${user.userId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(user)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>

      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteUser(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
